<div class="container__">
  <div class="header__ d__flex just-s">
    <p class="m-0 title">{{setting == 'print' ? 'Printer Setting': 'Short Cuts'}} </p>
    <ion-icon *ngIf="is_modal" class="close-ion-icon" src="assets/order_icon/close.svg" (click)="modalCtrl.dismiss()"></ion-icon>
  </div>
  <div *ngIf="setting == 'print'" class="input_box d__flex just-s">
    <p class="input_title">No of copy</p>
    <ion-input type="number" min="0" name="no_of_count" [(ngModel)]="count"></ion-input>
  </div>
  <p class="input_title pty">Print Type</p>
  <ion-item *ngIf="setting == 'print'" lines="none" class="">
    <!-- <ion-label position="stacked">Print Type</ion-label> -->
    <ion-select name="custom_role"[(ngModel)]="print_type" class="form-input p8" interface="popover" (ionChange)="value_changed($event)">
      <ion-select-option *ngFor="let c of print_list" value="{{c.name}}">{{c.name}}</ion-select-option>
    </ion-select>
  </ion-item>
  <!-- <div *ngIf="setting == 'print'" class="input_box d__flex just-s">
    <p class="input_title">Print Tpe</p>
    
  </div> -->
  <ion-list *ngIf="setting != 'print'" class="short_cuts">
    <ion-item>
      <ion-label><span>Ctrl + Shift + S</span> open payments</ion-label>
    </ion-item>
    <ion-item>
      <ion-label><span>Ctrl + C</span> open customers</ion-label>
    </ion-item>
    <!-- <ion-item>
      <ion-label><span>Ctrl + C</span>open customers</ion-label>
    </ion-item>
    <ion-item>
      <ion-label>Pac-Man</ion-label>
    </ion-item>
    <ion-item>
      <ion-label>Super Mario World</ion-label>
    </ion-item> -->
  </ion-list>
  <ion-button *ngIf="setting == 'print'" (click)="save_button()" class="save_button" fill="clear">Save</ion-button>
</div>
